<template>
  <div class="manager-holding-list">
    <slot></slot>
    <RkTable :auto-load-more="false" :data="data" :loading="loading" :finished="finished" @load="loadMore">
      <RkTableColumn prop="holderName" label="股东名称" fixed align="left" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.holderName).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="holdingNumber" label="持股数量" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.holdingNumber).convert() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="changeNumber" label="变动数量" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">
          <div :style="{ color: $digitjs(row.changeNumber).color() }">
            {{ $digitjs(row.changeNumber).prefix().convert() }}
          </div>
        </template>
      </RkTableColumn>
      <RkTableColumn prop="reportDate" label="发布日期" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.reportDate).isNull() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  methods: { postcssPatch },
  props: ['data', 'loading', 'finished', 'loadMore']
}
</script>

<style lang="scss" scoped>
.manager-holding-list {
  background: var(--bg-color-2);
}
</style>
